export const BREAKPOINTS = {
  Small: 'Small',
  Medium: 'Medium',
  Large: 'Large',
} as const

export const DEFAULT_BREAKPOINTS_CONFIG = {
  Small: 320,
  Medium: 768,
  Large: 1024,
}
